import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoPasskey16 = t0 => {
  const $ = _c(10);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  let t3;
  if ($[2] !== iconColor) {
    t2 = <path d="M7.99916 8.66667C5.46878 8.66667 3.6218 10.349 3.11356 12.6105C3.02742 12.9937 3.33863 13.3333 3.73147 13.3333H9.33249M10.3325 4.33333C10.3325 5.622 9.28783 6.66667 7.99916 6.66667C6.7105 6.66667 5.66586 5.622 5.66586 4.33333C5.66586 3.04467 6.7105 2 7.99916 2C9.28783 2 10.3325 3.04467 10.3325 4.33333Z" stroke={iconColor} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />;
    t3 = <path fillRule="evenodd" clipRule="evenodd" d="M12 7.33334C10.8954 7.33334 10 8.22874 10 9.33334C10 10.1405 10.4781 10.836 11.1667 11.152V13.5065C11.1667 13.6077 11.2127 13.7035 11.2918 13.7667L11.7918 14.1667C11.9135 14.2641 12.0865 14.2641 12.2082 14.1667L12.7082 13.7667C12.7873 13.7035 12.8333 13.6077 12.8333 13.5065V12.9513L12.3333 12.5L12.8333 12V11.152C13.5219 10.836 14 10.1405 14 9.33334C14 8.22874 13.1046 7.33334 12 7.33334ZM11.3333 9.33334C11.3333 8.96514 11.6318 8.66668 12 8.66668C12.3682 8.66668 12.6667 8.96514 12.6667 9.33334C12.6667 9.70154 12.3682 10 12 10C11.6318 10 11.3333 9.70154 11.3333 9.33334Z" fill={iconColor} />;
    $[2] = iconColor;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== ariaLabel || $[6] !== className || $[7] !== t2 || $[8] !== t3) {
    t4 = <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}{t3}</svg>;
    $[5] = ariaLabel;
    $[6] = className;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default IcoPasskey16;